
import axios from 'axios'
export const getProgram = async(organizationId, programId, only=true) => {
    if (!organizationId || !programId) {
        throw new Error('organizationId and programId are required');
    }
    let url = `/organization/${organizationId}/program/${programId}?withTemplate=true`
    if( only )
    {
        url += `&only=1`
    }
    const response = await axios.get(url)
    // console.log(response)
    const data = response.data;

    return data;
}